import { ArrowDownLeft, ArrowLeft, ArrowUpRight } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Transactions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: customer } = useSelector((state) => state.customer);

  const apiTransactions = customer?.transactions || [];

  const allTxs = [...apiTransactions]
    .sort(
      (a, b) =>
        new Date(b.transactionProcessedDate) -
        new Date(a.transactionProcessedDate)
    )
    .map((t) => {
      const detail = t.transactionDetail;
      const type = detail?.transactionType;

      const customerQualified =
        t.qualifiedCampaign?.find((q) => q.walletFor === "Customer")?.value || 0;

      let points = 0;
      let isPositive = false;

      if (type === "purchase") {
        points = Math.abs(customerQualified);
        isPositive = true;
      } else if (type === "redeem") {
        points = Math.abs(
          detail?.values || detail?.amount || detail?.rewardpoint || customerQualified
        );
        isPositive = false;
      } else {
        points = Math.abs(customerQualified);
        isPositive = customerQualified > 0;
      }

      const dateObj = new Date(t.transactionProcessedDate);
      return {
        id: t.id,
        productName: detail?.productName || null,
        quantity: detail?.quantity || null,
        qrcode: detail?.qrcode || null,
        points,
        isPositive,
        date: dateObj.toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
              bankdetails:detail.bankdetails,
        time: dateObj.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      };
    });

  return (
    <div className="min-h-screen bg-[#F5F6FA] flex justify-center">
      <div className="w-full max-w-md bg-white min-h-screen md:rounded-3xl md:shadow-lg">
        <div className="relative flex items-center justify-center border-b border-gray-100 px-4 py-4">
          <button
            onClick={() => navigate(-1)}
            className="absolute left-4 w-9 h-9 flex items-center justify-center rounded-full"
            style={{ backgroundColor: "#1A1F3610" }}
          >
            <ArrowLeft className="w-5 h-5 text-[#1A1F36]" />
          </button>
          <p className="text-base font-semibold text-[#1A1F36]">
            {t("transactions.all")}
          </p>
        </div>

        <div className="p-4">
          {allTxs.length === 0 && (
            <p className="text-center text-gray-400 mt-10">
              {t("transactions.emptyAll")}
            </p>
          )}

          <div className="bg-white rounded-3xl shadow-md border overflow-hidden">
            {allTxs.map((tx, i) => (
              <div
                key={tx.id}
                className={`flex items-center justify-between px-4 py-4 ${
                  i !== allTxs.length - 1 ? "border-b" : ""
                } hover:bg-gray-50 transition`}
              >
                {/* LEFT */}
                <div className="flex items-center gap-3">
                  <div
                    className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full ${
                      tx.isPositive
                        ? "bg-green-100 text-green-600"
                        : "bg-red-100 text-red-500"
                    }`}
                  >
                    {tx.isPositive ? (
                      <ArrowDownLeft size={18} />
                    ) : (
                      <ArrowUpRight size={18} />
                    )}
                  </div>

                  <div>
                    {/* Product name — dash if not available */}
                    <p className="text-sm font-semibold text-[#1A1F36]">
                      {tx.productName ? tx.productName : tx?.bankdetails}
                    </p>

                    {/* Qty • QR code — only if available */}
                    {(tx.quantity || tx.qrcode) && (
                      <p className="text-xs text-gray-400">
                        {tx.quantity ? `Qty: ${tx.quantity}` : ""}
                        {tx.quantity && tx.qrcode ? "  •  " : ""}
                        {tx.qrcode ? tx.qrcode : ""}
                      </p>
                    )}

                    {/* Date & time */}
                    <p className="text-xs text-gray-400">
                      {tx.date} • {tx.time}
                    </p>
                  </div>
                </div>

                {/* RIGHT */}
                <div className="text-right ml-2">
                  <p
                    className={`text-sm font-bold whitespace-nowrap ${
                      tx.isPositive ? "text-green-600" : "text-red-500"
                    }`}
                  >
                    {tx.isPositive ? "+" : "-"} ₹{tx.points}
                  </p>
                  <p className="text-[10px] text-gray-400 mt-1">
                    {tx.isPositive
                      ? t("transactions.credited")
                      : t("transactions.debited")}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}